export const TipoConsulta = [
    {
        codigo: 1,
        proceso: "CONSULTA_POR_POLIZA",
        opcion: "POLIZA"
    }, {
        codigo: 2,
        proceso: "CONSULTA_POR_DNI",
        opcion: "DNI EMPLEADOR"
    }, {
        codigo: 3,
        proceso: "CONSULTA_POR_CONSECUTIVO",
        opcion: "CONSECUTIVO"
    }];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/reporte_historico_rta/modelo/TipoConsulta.ts